import { render, staticRenderFns } from "./LearnerGuidePage.vue?vue&type=template&id=c0383b74&scoped=true&lang=pug"
import script from "./LearnerGuidePage.vue?vue&type=script&lang=ts"
export * from "./LearnerGuidePage.vue?vue&type=script&lang=ts"
import style0 from "./LearnerGuidePage.vue?vue&type=style&index=0&id=c0383b74&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0383b74",
  null
  
)

export default component.exports